module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rupert Fawcett\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Rupert Fawcett became a professional cartoonist almost by accident when in 1989, while doodling, he drew a bald man in braces and carpet slippers and called him Fred. The Fred cartoons went on to be syndicated in the "), _c('I', [_vm._v("Mail on Sunday ")]), _vm._v("and published in several books, including the recent "), _c('I', [_vm._v("Off the Leash. ")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15PiuzW/tc-custom/9781466864719.jpg?1734722238684",
      "alt": "This image is the cover for the book Off the Leash"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Off the Leash\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Originally launched on Facebook, Rupert Fawcett's charming and heartfelt "), _c('i', [_vm._v("Off the Leash ")]), _vm._v("cartoons have developed a huge daily following around the world. This books brings together the very best of those cartoons, featuring the secret thoughts and conversations of dogs of every size, shape and breed. The cartoons appeal to all sorts of people, from passionate dog lovers who have eight sleeping on their bed at night, to people who don't have any pets at all, but can still identify with the characteristics. Let's face it, who doesn't like to be fed, have their tummy stroked and snooze on the sofa in the afternoon? A celebration of our favorite belly-scratching, tail-chasing, bed-stealing canine friends.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Griffin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0